import omit from 'lodash-es/omit';
import { RawForm } from 'mk/forms/RawForm';
import { Context } from 'mk/interfaces';
import * as React from 'react';

interface OwnProps {
    context: Context;
    className?: string;
    action?: string;

    onClean?();
    onSubmit?(fieldValues, form);
    onError?(data, form);

    // Unused - but should have same interface as Form
    onSubmitSuccess?();
    onSubmitFailure?();
}

interface State {
    fieldValues: any;
    fieldErrors: any;
    formErrors: string[];
    isSubmitting: boolean;
    submitFailed: boolean;
}

const initialState = {
    fieldValues: {},
    fieldErrors: {},
    formErrors: [],
    isSubmitting: false,
    submitFailed: false,
};

export class FakeForm extends React.Component<OwnProps, State> {

    private fakeForm: HTMLFormElement;
    private rawForm: RawForm;

    constructor(props, context) {
        super(props, context);
        this.state = { ...initialState };
    }

    public componentDidUpdate(prevProps, prevState) {
        // if action url is set, post json data
        if (this.props.action && this.state.isSubmitting && !prevState.isSubmitting) {
            (this.fakeForm.elements as any).json.value = JSON.stringify(omit(this.state.fieldValues, 'json'));
            this.fakeForm.submit();
        }
    }

    public render() {
        return (
            <div className="fake-form">
                {this.props.action && (
                    <form ref={(r) => this.fakeForm = r} action={this.props.action} method="post">
                        <input type="hidden" name="csrfmiddlewaretoken" value={this.props.context.csrfToken} />
                        <input type="hidden" name="json" id="json" value="" />
                    </form>
                )}
                <RawForm
                    className={this.props.className}
                    onSubmit={this.onSubmit}
                    onError={this.onError}
                    onClean={this.props.onClean}
                    fieldErrors={this.state.fieldErrors}
                    formErrors={this.state.formErrors}
                    isSubmitting={this.state.isSubmitting}
                    ref={(r) => this.rawForm = r}
                >
                    {this.props.children}
                </RawForm>
            </div>
        );
    }

    public getFieldRef(name) {
        return this.rawForm.getFieldRef(name);
    }

    private onSubmit = (fieldValues) => {
        this.setState({
            fieldValues,
            isSubmitting: true,
        });

        if (this.props.onSubmit) {
            this.props.onSubmit(fieldValues, this);
        }
    };

    private onError = (data) => {
        this.setState({
            fieldValues: data.fieldValues,
            fieldErrors: data.fieldErrors,
            formErrors: data.formErrors,
            isSubmitting: false,
            submitFailed: true,
        });

        if (this.props.onError) {
            this.props.onError(data, this);
        }
    };
}
